import React from "react";
import {BaseComponent} from "@renta-apps/athenaeum-react-common";
import Mapping from "../../Models/Mapping";
import Category from "../../Models/Category";


import {Dictionary} from "typescript-collections";
import MappingRow from "@/components/MappingRow/MappingRow";

interface IMappingsPanelProps {

    inspections?: boolean;

    mappings: Mapping[];
    availableCategories: Dictionary<string, Set<Category>> | null;

    addCategoryAsync(mapping: Mapping, category: Category): Promise<void>;

    deleteCategoryAsync(mapping: Mapping, category: Category): Promise<void>;
}

interface IMappingsPanelState {
 
}

export default class MappingsPanel extends BaseComponent<IMappingsPanelProps, IMappingsPanelState> {

    state: IMappingsPanelState = {
       
    };

    public render(): React.ReactNode {
        return (
            <div className="container-xxl">
                {
                    this.props.mappings.map((mapping) => (
                        <MappingRow mapping={mapping}
                                    isInspectionsMapping={this.props.inspections} 
                                    availableCategories={this.props.availableCategories}
                                    addCategoryAsync={async (mapping: Mapping, category: Category) => await this.props.addCategoryAsync(mapping, category)}
                                    deleteCategoryAsync={async (mapping: Mapping, category: Category) => await this.props.deleteCategoryAsync(mapping, category)}
                        />
                    ))
                }
            </div>
        );
    }
}